import { render, staticRenderFns } from "./ElError.vue?vue&type=template&id=27d8268f&scoped=true&"
import script from "./ElError.vue?vue&type=script&lang=js&"
export * from "./ElError.vue?vue&type=script&lang=js&"
import style0 from "./ElError.vue?vue&type=style&index=0&id=27d8268f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d8268f",
  null
  
)

export default component.exports